import styled, { css } from 'styled-components'

export const EditorRoot = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	min-height: 0;
`

export const MaximizeToolbar = styled.div`
	display: flex;
	flex-shrink: 0;
	justify-content: flex-end;
	align-items: center;
	min-height: 28px;
`

export const Wrapper = styled.div<{ disabled?: boolean }>`
	position: relative;
	width: 100%;
	flex: 1;
	min-height: 0;
	${(props) =>
		props.disabled &&
		css`
			.ace_content {
				background: ${(props) => props.theme.colors.input.disabled.background};
			}
		`}
`

export const Maximizer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	line-height: 0;
`
